import { useStyles } from '@webapps/styles';
import ConventionModelContainer from './components/ConventionModelContainer';
import SmartFieldContainer from './components/SmartFieldContainer';
import { css, cx } from '@emotion/css';
import { EditorProvider } from 'context/editor/EditorContext';
import { createRef, useState } from 'react';
import ConventionContainer from './components/ConventionContainer';

export default function Convention() {
  const { classes } = useStyles(styles);

  const [selectedDocument, setSelectedDocument] = useState({});
  const [editorRef, setEditorRef] = useState(null);
  const [selectedConvention, setSelectedConvention] = useState({
    init: true,
    name: 'Défaut',
    content: [createRef()],
  });
  const [currentPageIndex, setCurrentPageIndex] = useState(1);


  return (
    <EditorProvider>
      <div className={cx(classes["container"], css({
        ".MuiButton-root": {
          minWidth: "inherit",
        }
      }))}>
        <div className={classes["model-and-smartfield-container"]}>
          <ConventionModelContainer
            selectedDocument={selectedDocument}
            setSelectedDocument={setSelectedDocument}
            setCurrentPageIndex={setCurrentPageIndex}
          />
          <SmartFieldContainer
            selectedDocument={selectedDocument}
            setSelectedDocument={setSelectedDocument}
            editorRef={editorRef}
            setSelectedConvention={setSelectedConvention}
            currentPageIndex={currentPageIndex}
          />
        </div>
        <ConventionContainer
          selectedDocument={selectedDocument}
          setSelectedDocument={setSelectedDocument}
          setEditorRef={setEditorRef}
          currentPageIndex={currentPageIndex}
          setCurrentPageIndex={setCurrentPageIndex}
          from="editor"
        />
      </div>
    </EditorProvider>
  );
}

const styles = ({ spacing }) => ({
  "container": {
    alignItems: "flex-start",
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "row",
    height: "min-content",
    justifyContent: "flex-start",
    paddingBottom: "50px",
    paddingLeft: "50px",
    paddingRight: "50px",
    position: "relative",
    width: "100%",
    gap: "30px",
    marginTop: "50px",
  },
  "model-and-smartfield-container": {
    alignContent: "center",
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    flex: "1.4 0 0",
    height: "min-content",
    position: "sticky",
    top: "50px",
    gap: "20px",
    overflow: "hidden",
    placeItems: "center",
  },
});